import { StudentData, TypeaheadOptions } from '../../util/types';
import { generateBlankStudentData } from '../../util/types';

const STUDENT_REGEX = /^student_(\d+)_(.+)/;

// Splits formData into non-student fields and StudentData array
const splitStudentsFromFormData = (formData: any) : [any, StudentData[]] => {
  const STUDENT_DATA_KEYS = Object.keys(generateBlankStudentData());

  return Object.entries(formData).reduce(([accumFiltered, accumStudents], [key, value]) => {
    const res = STUDENT_REGEX.exec(key);
    const student_index = parseInt(res?.[1] as string);
    const student_field_name = res?.[2];
    // console.log(student_index);
    // If not student field, save
    if (!student_field_name) {
      accumFiltered[key] = value;
    }
    // If student field, put into students array
    else {
      if (STUDENT_DATA_KEYS.includes(student_field_name)) {
        if (!accumStudents[student_index]) accumStudents[student_index] = generateBlankStudentData();
        accumStudents[student_index][student_field_name as keyof StudentData] = value as string & TypeaheadOptions; // Can be a string or TypeaheadOptions (for schools)
      }
    };
    return [accumFiltered, accumStudents];
  }, [{} as any, [] as StudentData[]]);
};

export default splitStudentsFromFormData;
